import { useState } from 'react'
import PropTypes from 'prop-types'
import Button from '@/shared/components/UI/Button'
import Textarea from '@/shared/components/UI/Textarea'
import CheckCircleIcon from '@/shared/icons/CheckCircleIcon'

const StepFeedback = ({ onSubmit, isLoading }) => {
  const [first, setFirst] = useState('')
  const [second, setSecond] = useState('')
  const [third, setThird] = useState('')

  return (
    <div className="flex flex-col gap-v3-md w-full">
      {/* Confirmation banner */}
      <div className="rounded-v3-md bg-v3-black-lightest border border-v3-black-card p-v3-sm flex items-center gap-v3-sm">
        <CheckCircleIcon className="text-v3-green-dark w-5 h-5 flex-shrink-0" />
        <p className="text-v3-h10 text-v3-black-primary">
          Your subscription has been cancelled. You&apos;ll have access until the end of your
          billing period.
        </p>
      </div>

      {/* Header */}
      <div className="flex flex-col gap-v3-xs">
        <h3 className="text-v3-h4 font-bold text-v3-black-max">Before you go, help us improve</h3>
        <p className="text-v3-black-secondary text-v3-h9">
          Your answers help us build a better product. This takes about 1 minute.
        </p>
      </div>

      {/* Questions */}
      <div className="flex flex-col gap-v3-sm">
        <Textarea
          label="What initially made you excited about Dante AI?"
          placeholder="e.g. The AI training, the promise of automation..."
          value={first}
          onChange={(e) => setFirst(e.target.value)}
          rows={3}
        />
        <Textarea
          label="What didn't work the way you expected?"
          placeholder="e.g. The bot wasn't answering correctly, setup was confusing..."
          value={second}
          onChange={(e) => setSecond(e.target.value)}
          rows={3}
        />
        <Textarea
          label="What would need to change for you to come back?"
          placeholder="e.g. Lower price, better integrations, more reliable answers..."
          value={third}
          onChange={(e) => setThird(e.target.value)}
          rows={3}
        />
      </div>

      {/* Submit */}
      <div className="flex flex-col items-center gap-v3-xs">
        <Button
          variant="primary"
          size="lg"
          label="Submit feedback"
          onClick={() => onSubmit({ first, second, third })}
          loading={isLoading}
          loadingLabel="Submitting..."
        />
        <p className="text-[12px] text-v3-black-secondary text-center">
          All fields are optional - submit whenever you&apos;re ready.
        </p>
      </div>
    </div>
  )
}

StepFeedback.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
}

StepFeedback.defaultProps = {
  isLoading: false,
}

export default StepFeedback
